module.exports = __webpack_public_path__ + "img/ws_gold.df98a807.png";